import { FormRadioButton } from "@/components/molecules/forms/FormRadioButton";
import { BusinessType } from "@/generated/graphql";
import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { FormErrorMessage } from "@/components/molecules";

type Props = {
  name: string;
};

export const BusinessTypeFormField = ({ name }: Props) => {
  return (
    <div css={container}>
      <div
        css={{
          display: "flex",
          alignItems: "center",
          justifyItems: "start",
          gap: "4px",
          width: "160px",
          marginRight: "16px",
          paddingTop: "10px",
          paddingBottom: "4px",
        }}
      >
        <Font variant="m" component="p">
          事業形態 <Label variant="required" />
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={{ display: "flex", gap: "16px" }}>
          <FormRadioButton
            name={name}
            value={BusinessType.Corporate}
            label="法人"
            registerOptions={{
              required: "選択してください",
            }}
          />
          <FormRadioButton
            name={name}
            value={BusinessType.Individual}
            label="個人事業主"
            registerOptions={{
              required: "選択してください",
            }}
          />
        </div>
        <div css={errorWrapper}>
          <FormErrorMessage name={name} />
        </div>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  alignItems: "start",
});

const labelWrapper = css({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
  paddingTop: "10px",
  paddingBottom: "4px",
});

const errorWrapper = css({
  flex: 1,
});
